module.exports = __webpack_public_path__ + "img/nf.cc20348d.svg";